import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type RequestTypeDto = {
  requestType: string;
  requestTaskTypes: RequestTaskTypeDto[];
};

type RequestTaskTypeDto = {
  taskTypeName: string;
  EnableCommercial: boolean;
};

type ListDrsRequestTypesResponse = {
  requestTypes: RequestTypeDto[];
};

export const listRequestTypes = async () => {
  const response = await executeApiRequest(() => axios.get<ListDrsRequestTypesResponse>("/requests/requesttypes"));
  return response?.data.requestTypes;
};
